import React, { ReactElement } from 'react';
import cs from 'classnames';
import style from './style.module.scss';

interface FilmTrackProps {
    className?: string
    children: ReactElement | ReactElement[]
    classNames?: {
        container?: string
    },
    x: number | string
}

export const FilmTrack = ({
  className, children, x, classNames,
}: FilmTrackProps): ReactElement => (
  <div className={cs(style.filmTrack, className)}>
    <div className={cs(style.filmContainer, classNames?.container)} style={{ transform: `translateX(${x})` }}>{children}</div>
  </div>
);

FilmTrack.defaultProps = {
  className: undefined,
  classNames: {
    container: undefined,
  },
};
